import { configureStore } from '@reduxjs/toolkit';

import bannerReducer from './menu/BannersSlice';
import productReducer from './menu/ProductSlice';
import categoriesReducer from './menu/CategoriesSlice';
import profileReducer from './menu/ProfileSlice';
import CartReducer from './menu/cartSlice';
import storesReducer from './menu/StoresSlice';
import subCategoriesReducer from './menu/SubCategoriesSlice';


export const store = configureStore({
  reducer: {
    category: categoriesReducer,
    product: productReducer,
    banner: bannerReducer,
    profile: profileReducer,
    cart : CartReducer,
    stores: storesReducer,
    subCategory: subCategoriesReducer,
  },
});
